import { Box, Typography, CircularProgress } from '@mui/material';
import { FC } from 'react';

interface AudioPlayerProps {
    callRecordingUrl: string | null;
    errorMessage: string | null;
    isLoading: boolean;
    handleLoadedData: () => void;
    handleCanPlay: () => void;
    handleAudioError: () => void;
}

const AudioPlayer: FC<AudioPlayerProps> = ({
    callRecordingUrl,
    errorMessage,
    isLoading,
    handleLoadedData,
    handleCanPlay,
    handleAudioError,
}) => {
    if (errorMessage || !callRecordingUrl) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: 68,
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    {errorMessage || 'No call recording available.'}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ position: 'relative', width: '100%', minHeight: 40 }}>
            {isLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        backgroundColor: 'background.paper',
                        zIndex: 1,
                    }}
                >
                    <CircularProgress size={18} />
                    <Typography variant="body2" color="text.secondary">
                        Loading recording...
                    </Typography>
                </Box>
            )}
            <audio
                controls
                style={{ width: '100%', marginTop: '0.5rem' }}
                key={callRecordingUrl}
                src={callRecordingUrl}
                onLoadedData={handleLoadedData}
                onCanPlay={handleCanPlay}
                onError={handleAudioError}
            />
        </Box>
    );
};

export default AudioPlayer;
